var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"le"},[_c('v-card',{staticClass:"le-card"},[_c('div',{staticClass:"le-card__head"},[_c('v-icon',{staticClass:"le-card__icon",attrs:{"small":""}},[_vm._v("mdi-image-multiple-outline")]),_vm._v(" Theme-Vorschaubilder ")],1),_c('ThemePreviewsPanel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }